<div class="card-wrapper d-flex flex-column">
  <div class="card-header d-flex flex-row justify-content-between">
    <span class="ellipsis" [tooltip]="cardDetails?.customPrize?.customPrizeLabel || ''">{{ cardDetails.type ===
      SPIN_WIN_PRIZES.CUSTOM ? cardDetails?.customPrize?.customPrizeLabel:
      cardDetails.nft
      ? "NFT"
      : cardDetails.type === SPIN_WIN_PRIZES.CASH ? ("cash" | translate) : cardDetails.type !==
      SPIN_WIN_PRIZES.FREE_SPIN ?
      (cardDetails.currency?.currencyName | uppercase)
      : (("free" | translate) + ' ' +("spin" | translate)) | titlecase
      }}</span>
    <span>{{ cardDetails.probability | roundAndTrim }}%</span>
  </div>
  <div class="card-body d-flex flex-column" [ngClass]="{'pt-2': cardDetails.type === SPIN_WIN_PRIZES.NFT}">
    <div *ngIf="cardDetails.type === SPIN_WIN_PRIZES.NFT || cardDetails.type === SPIN_WIN_PRIZES.CUSTOM; else noNFT"
      class="d-flex flex-column gap-sm-1 gap-1 card-container" (click)="onAction.emit(ACTIONS.CLICK)"
      [ngClass]="{'cursor-pointer' :cardDetails.type === SPIN_WIN_PRIZES.NFT}">
      <div class="nft-name d-flex flex-column">
        <ng-container *ngIf="cardDetails.nft; else customTitle">
          <span class="ellipsis"
            [tooltip]="getEllipsis((cardDetails.nft.id).toString(), 28).includes('...') ? cardDetails.nft.id.toString() : ''"
            containerClass="tooltipClass">
            #{{ getEllipsis((cardDetails.nft.id).toString(), 28) }}</span>
          <span class="ellipsis nft-collection-name"
            [tooltip]="getEllipsis(cardDetails.nft.name || '', 28).includes('...') ? cardDetails.nft.name : ''"
            containerClass="tooltipClass">
            {{ getEllipsis(cardDetails.nft.name || '', 28) }}
          </span>
        </ng-container>
        <ng-template #customTitle>
          <span class="ellipsis" [tooltip]="cardDetails?.customPrize?.customPrizeDesc"
            [tooltipEnable]="getEllipsis((cardDetails?.customPrize?.customPrizeDesc || ''), 28).includes('...')"
            containerClass="tooltipClass">
            {{ getEllipsis((cardDetails?.customPrize?.customPrizeDesc || ''), 28) }}</span>
        </ng-template>
      </div>
      <div class="prize-img">
        <app-custom-image class="nft-card-img" [src]="cardDetails.nft?.img || cardDetails.imageUrl"
          [alt]="'game-image'"></app-custom-image>
      </div>
    </div>
    <ng-template #noNFT>
      <div class="non-nft-prize d-flex flex-column justify-content-center align-items-center">
        <app-custom-image [src]="cardDetails.imageUrl ? cardDetails.imageUrl :
                    cardDetails.type === SPIN_WIN_PRIZES.CASH ? '/assets/images/cash-reward-card.png'
                    : cardDetails.tokenQuantity ? '/assets/images/token-chest-card.png' : '/assets/images/free-spin-card.svg'
          " [alt]="'game-image'" class="w-100 h-100 non-nft-card-img"></app-custom-image>
      </div>
    </ng-template>
    <div [ngSwitch]="cardDetails.type" class="card-info">
      <div *ngSwitchCase="SPIN_WIN_PRIZES.FREE_SPIN"
        class="free-spin d-flex flex-column justify-content-center align-items-center">
        <span class="spin-count">{{cardDetails.numberOfFreeSpin}}&nbsp;{{"spin" | translate | titlecase}}</span>
        <span class="lootboxes" translate>lootboxes</span>
      </div>

      <div *ngSwitchCase="SPIN_WIN_PRIZES.NFT" class="range-bar">
        <app-range-bar *ngIf="cardDetails.nft" [rangeData]="cardDetails.nft"></app-range-bar>
      </div>
      <div *ngSwitchCase="SPIN_WIN_PRIZES.CUSTOM" class="wsm-tokens d-flex flex-row gap-sm-1 justify-content-center">
        <ng-container *ngIf="cardDetails!.tokenQuantity">
          <img
            [src]="cardDetails.unit === CURRENCY.USD ? 'assets/images/svg-icons/usd-coin.svg' : 'assets/images/svg-icons/euro-coin.svg'"
            class="currency-symbol" alt="wsm" />
          <span class="wsm-amount"><span class="amount-currency">{{cardDetails.unit === CURRENCY.USD ?
              CURRENCY_SYMBOL.USD
              : CURRENCY_SYMBOL.EURO}}</span>{{
            convertNumToCurr(cardDetails!.tokenQuantity) }}</span>
        </ng-container>
      </div>
      <div *ngSwitchDefault class="wsm-tokens d-flex flex-row gap-sm-1 justify-content-center">
        <img
          [src]="cardDetails.type === SPIN_WIN_PRIZES.CASH ? cardDetails.unit === CURRENCY.USD ? 'assets/images/svg-icons/usd-coin.svg' : 'assets/images/svg-icons/euro-coin.svg' :cardDetails.currency?.currencySymbol"
          alt="wsm"
          [ngClass]="{'wsm-token-logo' :cardDetails.type !== SPIN_WIN_PRIZES.CASH && cardDetails.type !== SPIN_WIN_PRIZES.CASINO_TOKEN , 'currency-symbol': true}" />
        <span class="wsm-amount"><span class="amount-currency">{{ cardDetails.type !== SPIN_WIN_PRIZES.CASINO_TOKEN ?
            cardDetails.unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD
            : CURRENCY_SYMBOL.EURO : ''}}</span>{{
          convertNumToCurr(cardDetails!.tokenQuantity ?? 0) }}
          {{ cardDetails.currency?.currencyName | uppercase }}</span>
      </div>
    </div>
  </div>
</div>